import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";

import { FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api.js";
import apiInstance from "../../../../Utils/api.js";
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;
  const navigate = useNavigate();
  const [procedures, setProcedures] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [generalList, setGeneralList] = useState([]);

  const [macid, setMacId] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState("");

  const [showMedItem, setShowMedItem] = useState(false);
  const [showProMedItem, setShowProMedItem] = useState(false);
  const [showProAccItem, setShowProAccItem] = useState(false);
  const [showGenItem, setShowGenItem] = useState(false);
  const [date, setDate] = useState("");
  const [bankRadioValue, setBankRadioValue] = useState("");
  const [cashRadioValue, setCashRadioValue] = useState("");
  const [showBank, setShowBank] = useState(false);
  const [showCash, setShowCash] = useState(false);
  const [relatedBankAcc, setRelatedBankAcc] = useState("");
  const [relatedCashAcc, setRelatedCashAcc] = useState("");
  const [bankList, setBankList] = useState([]);
  const [cashList, setCashList] = useState([]);
  const [recMedQty, setRecMedQty] = useState(0);
  const [recProQty, setRecProQty] = useState("");
  const [recGenQty, setRecGenQty] = useState("");

  const [recProAssQty, setRecProAssQty] = useState("");
  const [medRecievedQty, setMedRecievedQty] = useState([]);

  const [proRecievedQty, setProRecievedQty] = useState("");
  const [proAssRecievedQty, setProAssRecievedQty] = useState("");

  const [proFlag, setProFlag] = useState("");
  const [medFlag, setMedFlag] = useState("");

  const [proAssFlag, setProAssFlag] = useState("");

  // const purId = useLocation().pathname.split('/')[2]

  const Id = useLocation().pathname.split("/")[2];
  const location = useLocation();
  const data = location.state.data.relatedApprove;
  const RecievedQtyData = location.state.data;

  const branchID = location.state.data.relatedBranch
    ? location.state.data.relatedBranch._id
    : "";

  // console.log(RecievedQtyData, 'state')
  // console.log(location.state.data, 'rec')

  useEffect(() => {
    const getMedicine = async () => {
      setMedicineList(data?.medicineItems);

      if (data?.medicineItems[0]) {
        setMedRecievedQty(
          RecievedQtyData.medicineItems ? RecievedQtyData.medicineItems : "",
        );

        setMedFlag(
          RecievedQtyData.medicineItem ? RecievedQtyData.medicineItems : "",
        );
        setShowMedItem(true);

        // setTranQtyZero(data.medicineItems ? data.medicineItems: '')
      }
    };

    const getProcedures = async () => {
      setProcedures(data?.procedureItems);
      if (data?.procedureItems[0]) {
        setProRecievedQty(
          RecievedQtyData.procedureItems.filter(
            (el) =>
              el._id ==
              (data.procedureItems
                ? data.procedureItems.map((i) => i._id)
                : ""),
          )[0]
            ? RecievedQtyData.procedureItems.filter(
                (el) =>
                  el._id ==
                  (data.procedureItems
                    ? data.procedureItems.map((i) => i._id)
                    : ""),
              )[0].recievedQty
            : "",
        );
        setProFlag(
          RecievedQtyData.procedureItems ? RecievedQtyData.procedureItems : "",
        );
        setShowProMedItem(true);
      }
    };
    const getAccessories = async () => {
      if (data?.accessoryItems[0]) {
        setAccessories(data?.accessoryItems);

        setShowProAccItem(true);
      }
    };
    const getGeneral = async () => {
      if (data?.generalItems[0]) {
        setGeneralList(data?.generalItems);

        setShowGenItem(true);
      }
    };

    const getBranches = async () => {
      const res = await api.get("branches");
      setBranchList(res.data.list);
    };

    const getPurchaseDetail = async () => {
      const res = await api.get("purchase-request/" + Id);
      // console.log(res.data.data, 'con')
      setDate(res.data.data.date ? res.data.data.date.split("T")[0] : "");
      setBranchName(
        res.data.data.relatedBranch ? res.data.data.relatedBranch.name : "HO",
      );
    };
    const getCashLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const cash = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash In Hand" &&
            el.relatedType.name === "Assets",
        );
        setCashList(cash);
      } catch (err) {}
    };

    const getBankLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const bank = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash At Bank" &&
            el.relatedType.name === "Assets",
        );
        setBankList(bank);
      } catch (err) {}
    };
    getCashLists();
    getGeneral();
    getBankLists();
    getPurchaseDetail();
    getBranches();

    getMedicine();

    getProcedures();
    getAccessories();
  }, []);
  // console.log(recQty, 'pro')

  const handleMedRec = (med, medRec) => {
    // console.log(medRec, 'med', recMedQty, 'redcMedQty')
    // console.log(recMedQty, 'recMedQty')

    const data = {
      relatedPurchase: Id,
      medicineItemID: med.item_id._id,
      requestedQty: med.transferQty,
      recievedQty: recMedQty,
      // relatedBranch: branchID,
      toUnit: med.item_id.toUnit,
      fromUnit: med.item_id.fromUnit,
    };

    if (
      med.transferQty === parseInt(recMedQty) ||
      medRec === parseInt(recMedQty)
    ) {
      data.isDone = true;
    } else {
      data.isDone = false;
    }

    if (!branchID) {
    } else {
      data.relatedBranch = branchID;
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("purchases/recieve", data, config)

      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Received",
          icon: "success",

          cancelButtonText: "Close",
        });
        // navigate('/purchaseDetail/' + Id)

        // navigate('/pur-rec/' + Id)
      })

      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleProRec = (pro, proRec) => {
    // console.log(proRec, 'tran')
    // console.log(recProQty, 'pro')

    const data = {
      relatedPurchase: Id,
      procedureItemID: pro.item_id._id,
      requestedQty: pro.transferQty,
      recievedQty: recProQty,
      toUnit: pro.item_id.toUnit,
      fromUnit: pro.item_id.fromUnit,
    };

    if (
      pro.transferQty == parseInt(recProQty) ||
      proRec === parseInt(recProQty)
    ) {
      data.isDone = true;
    } else {
      data.isDone = false;
    }

    if (!branchID) {
    } else {
      data.relatedBranch = branchID;
    }
    // console.log(pro.transferQty == recProQty, 'eq')

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("purchases/recieve", data, config)

      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Received",
          icon: "success",

          cancelButtonText: "Close",
        });
        // navigate('/purchaseDetail/' + Id)
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleProAssRec = (proass, proAssRec) => {
    // console.log(recProAssQty, 'pro ass')

    const data = {
      relatedPurchase: Id,
      accessoryItemID: proass.item_id._id,
      requestedQty: proass.transferQty,
      recievedQty: recProAssQty,
      // relatedBranch: branchID,
      toUnit: proass.item_id.toUnit,
      fromUnit: proass.item_id.fromUnit,
    };

    if (
      proass.transferQty === parseInt(recProAssQty) ||
      proAssRec === parseInt(recProAssQty)
    ) {
      data.isDone = true;
    } else {
      data.isDone = false;
    }

    if (!branchID) {
    } else {
      data.relatedBranch = branchID;
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("purchases/recieve", data, config)

      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Received",
          icon: "success",

          cancelButtonText: "Close",
        });
        // navigate('/purchaseDetail/' + Id)
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleGenRec = (gen, genRec) => {
    // console.log(gen, 'pro ass')

    const data = {
      relatedPurchase: Id,
      generalItemID: gen.item_id._id,
      requestedQty: gen.transferQty,
      recievedQty: recGenQty,
      // relatedBranch: branchID,
      toUnit: gen.item_id.toUnit,
      fromUnit: gen.item_id.fromUnit,
    };

    if (
      gen.transferQty === parseInt(recGenQty) ||
      genRec === parseInt(recGenQty)
    ) {
      data.isDone = true;
    } else {
      data.isDone = false;
    }

    if (!branchID) {
    } else {
      data.relatedBranch = branchID;
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("purchases/recieve", data, config)

      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Received",
          icon: "success",

          cancelButtonText: "Close",
        });
        // navigate('/purchaseDetail/' + Id)
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={"/purchaseDetail/" + Id}>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Received</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card px-2 py-3 bg-light row">
                <h2>
                  <b>
                    Purchase Received For{" "}
                    <b className="text-decoration-underline">{branchName}</b>
                  </b>
                </h2>
                {/* <div className='row offset-4 -md-4'>
                  <div className='col-md-2'>
                    <div className='form-check form-check-inline mt-2 '>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='bank_cash'
                        id='bank'
                        value='1'
                        onClick={e => handleBankRadioChange(e.target.value)}
                        style={{
                          height: '27px',
                          width: '25px',
                          verticalAlign: 'middle'
                        }}
                      />
                      &nbsp;
                      <label
                        className='form-check-label text-success'
                        for='bank'
                      >
                        Bank
                      </label>
                    </div>
                  </div>
                  <div className='col-md-2'>
                    <div className='form-check form-check-inline mt-2 px-4'>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='bank_cash'
                        id='cash'
                        value='2'
                        onClick={e => handleCashRadioChange(e.target.value)}
                        style={{
                          height: '27px',
                          width: '25px',
                          verticalAlign: 'middle'
                        }}
                      />
                      <label
                        className='form-check-label text-success'
                        for='cash'
                      >
                        Cash
                      </label>
                    </div>
                  </div>
                </div> */}

                <div className="offset-2 col-8 py-3">
                  {showBank && (
                    <div className="form-group mt-3" id="bankkk">
                      <label className="control-label">Bank Account</label>

                      <select
                        className="form-control"
                        name="bank_acc"
                        id="bank_acc"
                        onChange={(e) => setRelatedBankAcc(e.target.value)}
                      >
                        <option value="">Select Bank Account</option>

                        {bankList.map((option) => (
                          <option value={option._id}>{option.name}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  {showCash && (
                    <div className="form-group mt-3" id="cashhh">
                      <label className="control-label">Cash Account</label>

                      <select
                        className="form-control"
                        name="cash_acc"
                        id="cash_acc"
                        onChange={(e) => setRelatedCashAcc(e.target.value)}
                      >
                        <option value="">Select Cash Account</option>
                        {/* @foreach ($cash_account as $acc) */}
                        {cashList.map((option) => (
                          <option value={option._id}>{option.name}</option>
                        ))}

                        {/* @endforeach */}
                      </select>
                    </div>
                  )}

                  {/* <div className='row'>
                    <div className='col-4 form-group '>
                      <Label>Received No</Label>
                      <Input
                        type='text'
                        className='form-control'
                        // onChange={e => setName(e.target.value)}
                      />
                    </div>
                    <div className='col-4 form-group'>
                      <Label>
                        Received By<Span>*</Span>
                      </Label>
                      <Input
                        type='text'
                        className='form-control'
                        // onChange={e => setTreatmentCode(e.target.value)}
                      />
                    </div>
                    <div className='col-4 form-group'>
                      <Label>Purchase Req Date</Label>
                      <Input
                        type='date'
                        className='form-control'
                        value={date}
                        // onChange={e => setTreatmentTime(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-4 form-group mt-2'>
                      <Label>Received Branch</Label>
                      <select
                        className='form-control'
                        onChange={e => handleBranch(e.target.value)}
                      >
                        <Option hidden>Select Branch</Option>
                        {branchList.map((option, index) => (
                          <Option value={option._id}>{option.name}</Option>
                        ))}
                      </select>
                    </div>

                    <div className='col-4 form-group'>
                      <Label>Supplier Purchase No</Label>
                      <Input
                        type='text'
                        className='form-control'
                        onChange={e => setSupplierNo(e.target.value)}
                      />
                    </div>
                    <div className='col-4 form-group'>
                      <Label>Received Date</Label>
                      <Input
                        type='Date'
                        className='form-control'
                        onChange={e => setRecDate(e.target.value)}
                      />
                    </div>
                    <div className='col-4 form-group'>
                      <Label>Remark</Label>
                      <Input
                        type='text'
                        className='form-control'
                        onChange={e => setRemark(e.target.value)}
                      />
                    </div>
                  </div> */}

                  {showMedItem && (
                    <div className="col-12 form-group mt-3">
                      <h3>Medicine</h3>
                      <table className="table table-responsive">
                        <thead>
                          <tr>
                            <th style={{ fontWeight: "400px" }}>#</th>

                            <th style={{ fontWeight: "400px" }}>Name</th>
                            <th style={{ fontWeight: "400px" }}>
                              Approved Qty
                            </th>
                            <th>Left Received Qty</th>

                            <th style={{ fontWeight: "400px" }}>
                              Received Qty
                            </th>

                            <th
                              className="text-center"
                              style={{ fontWeight: "400px" }}
                            >
                              {/* Action */}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {medicineList.map((med, index) => (
                            <tr>
                              {console.log(
                                RecievedQtyData.medicineItems[index]
                                  .recievedQty,
                                "hereitis",
                              )}

                              <td>{++index}</td>
                              {/* <td>{med.code}</td> */}

                              <td>{med.item_id.medicineItemName}</td>

                              <td>
                                <input
                                  type="number"
                                  defaultValue={med.transferQty}
                                  disabled
                                  className="form-control"
                                />
                              </td>
                              {console.log(
                                RecievedQtyData.medicineItems[index - 1]
                                  .recievedQty,
                                "index",
                              )}
                              <td>
                                <input
                                  type="text"
                                  value={
                                    RecievedQtyData.medicineItems[index - 1]
                                      ? RecievedQtyData.medicineItems[index - 1]
                                          .recievedQty
                                      : "0"
                                  }
                                  disabled
                                  className="form-control"
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  onChange={(e) => setRecMedQty(e.target.value)}
                                  className="form-control"
                                />
                              </td>

                              {RecievedQtyData.medicineItems[index - 1].flag ===
                              true ? (
                                <td className="text-center">
                                  <button
                                    onClick={(e) => handleMedRec(med)}
                                    className="btn btn-sm btn-dark mt-2"
                                    disabled
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              ) : (
                                <td className="text-center">
                                  <button
                                    onClick={(e) =>
                                      handleMedRec(
                                        med,
                                        RecievedQtyData.medicineItems[index - 1]
                                          .recievedQty,
                                      )
                                    }
                                    className="btn btn-sm btn-dark mt-2"
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {/* NOTE Procedure Medicine */}
                  {showProMedItem && (
                    <div className="col-12 form-group mt-3">
                      <h3>Procedure Medicine</h3>
                      <table className="table table-responsive">
                        <thead>
                          <tr>
                            <th style={{ fontWeight: "400px" }}>#</th>

                            <th style={{ fontWeight: "400px" }}>Name</th>
                            <th style={{ fontWeight: "400px" }}>
                              Approved Qty
                            </th>
                            <th>Left Received Qty</th>

                            <th style={{ fontWeight: "400px" }}>
                              Received Qty
                            </th>

                            <th
                              className="text-center"
                              style={{ fontWeight: "400px" }}
                            >
                              {/* Action */}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {procedures.map((proAssUnit, index) => (
                            <tr>
                              <td>{++index}</td>
                              {/* <td>{proAssUnit.code}</td> */}

                              <td>{proAssUnit.item_id.procedureItemName}</td>

                              <td>
                                <input
                                  type="number"
                                  defaultValue={proAssUnit.transferQty}
                                  disabled
                                  className="form-control"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  value={
                                    RecievedQtyData.procedureItems[index - 1]
                                      ? RecievedQtyData.procedureItems[
                                          index - 1
                                        ].recievedQty
                                      : "Not Set"
                                  }
                                  disabled
                                  className="form-control"
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  onChange={(e) => setRecProQty(e.target.value)}
                                  className="form-control"
                                />
                              </td>

                              {RecievedQtyData.procedureItems[index - 1].flag ==
                              true ? (
                                <td className="text-center">
                                  <button
                                    onClick={(e) => handleProRec(proAssUnit)}
                                    className="btn btn-sm btn-dark mt-2"
                                    disabled
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              ) : (
                                <td className="text-center">
                                  <button
                                    onClick={(e) =>
                                      handleProRec(
                                        proAssUnit,
                                        RecievedQtyData.procedureItems[
                                          index - 1
                                        ].recievedQty,
                                      )
                                    }
                                    className="btn btn-sm btn-dark mt-2"
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {showProAccItem && (
                    <div className="col-12 form-group mt-3">
                      <h3>Procedure Accessory</h3>
                      <table className="table table-responsive">
                        <thead>
                          <tr>
                            <th style={{ fontWeight: "400px" }}>#</th>

                            <th style={{ fontWeight: "400px" }}>Name</th>
                            <th style={{ fontWeight: "400px" }}>
                              Approved Qty
                            </th>
                            <th>Left Received Qty</th>

                            <th style={{ fontWeight: "400px" }}>
                              Received Qty
                            </th>

                            <th
                              className="text-center"
                              style={{ fontWeight: "400px" }}
                            >
                              {/* Action */}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {accessories.map((proAssUnit, index) => (
                            <tr>
                              <td>{++index}</td>
                              {/* <td>{proAssUnit.code}</td> */}

                              <td>{proAssUnit.item_id.accessoryItemName}</td>

                              <td>
                                <input
                                  type="number"
                                  defaultValue={proAssUnit.transferQty}
                                  disabled
                                  className="form-control"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  value={
                                    RecievedQtyData.accessoryItems[index - 1]
                                      ? RecievedQtyData.accessoryItems[
                                          index - 1
                                        ].recievedQty
                                      : "Not Set"
                                  }
                                  disabled
                                  className="form-control"
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  onChange={(e) =>
                                    setRecProAssQty(e.target.value)
                                  }
                                  className="form-control"
                                />
                              </td>

                              {RecievedQtyData.accessoryItems[index - 1].flag ==
                              true ? (
                                <td className="text-center">
                                  <button
                                    onClick={(e) => handleProAssRec(proAssUnit)}
                                    className="btn btn-sm btn-dark mt-2"
                                    disabled
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              ) : (
                                <td className="text-center">
                                  <button
                                    onClick={(e) =>
                                      handleProAssRec(
                                        proAssUnit,
                                        RecievedQtyData.accessoryItems[
                                          index - 1
                                        ].recievedQty,
                                      )
                                    }
                                    className="btn btn-sm btn-dark mt-2"
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {showGenItem && (
                    <div className="col-12 form-group mt-3">
                      <h3>General Items</h3>
                      <table className="table table-responsive">
                        <thead>
                          <tr>
                            <th style={{ fontWeight: "400px" }}>#</th>

                            <th style={{ fontWeight: "400px" }}>Name</th>
                            <th style={{ fontWeight: "400px" }}>
                              Approved Qty
                            </th>
                            <th>Left Received Qty</th>

                            <th style={{ fontWeight: "400px" }}>
                              Received Qty
                            </th>

                            <th
                              className="text-center"
                              style={{ fontWeight: "400px" }}
                            >
                              {/* Action */}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {generalList.map((genUnit, index) => (
                            <tr>
                              <td>{++index}</td>
                              {/* <td>{proAssUnit.code}</td> */}

                              <td>
                                {genUnit.item_id.accessoryItemName ||
                                  genUnit.item_id.generalItemName}
                              </td>

                              <td>
                                <input
                                  type="number"
                                  defaultValue={genUnit.transferQty}
                                  disabled
                                  className="form-control"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  value={
                                    RecievedQtyData.generalItems[index - 1]
                                      ? RecievedQtyData.generalItems[index - 1]
                                          .recievedQty
                                      : "Not Set"
                                  }
                                  disabled
                                  className="form-control"
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  onChange={(e) => setRecGenQty(e.target.value)}
                                  className="form-control"
                                />
                              </td>

                              {RecievedQtyData.generalItems[index - 1].flag ==
                              true ? (
                                <td className="text-center">
                                  <button
                                    onClick={(e) => handleGenRec(genUnit)}
                                    className="btn btn-sm btn-dark mt-2"
                                    disabled
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              ) : (
                                <td className="text-center">
                                  <button
                                    onClick={(e) =>
                                      handleGenRec(
                                        genUnit,
                                        RecievedQtyData.generalItems[index - 1]
                                          .recievedQty,
                                      )
                                    }
                                    className="btn btn-sm btn-dark mt-2"
                                    //data-toggle='modal'
                                    // data-target='#edit_stock{{$list->id}}'
                                  >
                                    Receive
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                {/* <Top>
                  <Center>
                    <Button onClick={create}>Save</Button>
                  </Center>
                </Top> */}
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
